import { render, staticRenderFns } from "./home-category.vue?vue&type=template&id=ee07f700&scoped=true"
import script from "./home-category.vue?vue&type=script&lang=ts&setup=true"
export * from "./home-category.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./home-category.vue?vue&type=style&index=0&id=ee07f700&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee07f700",
  null
  
)

export default component.exports